import React, { useState } from 'react';
import { Lock, ShieldCheck } from 'lucide-react';
import { authApi } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { mdpConforme } from '../../utils/motDePasse';
import ReglesMotDePasse from '../../components/ReglesMotDePasse';

// Première connexion avec le mot de passe provisoire reçu par e-mail :
// l'utilisateur doit choisir son propre mot de passe avant d'accéder à l'application.
export default function ChangerMotDePassePage() {
  const { user, logout, mdpChange } = useAuth();
  const [ancien, setAncien] = useState('');
  const [nouveau, setNouveau] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mismatch = confirm.length > 0 && nouveau !== confirm;

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!mdpConforme(nouveau)) { setError('Le nouveau mot de passe ne respecte pas toutes les règles.'); return; }
    if (nouveau !== confirm) { setError('Les deux mots de passe ne correspondent pas.'); return; }
    setLoading(true);
    try {
      await authApi.changerMdp(ancien, nouveau);
      mdpChange();
    } catch (err) {
      setError(err.response?.data?.error || 'Modification impossible.');
      setLoading(false);
    }
  };

  const input = 'w-full pl-9 pr-3 py-2.5 border border-cream-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-navy-300 focus:border-transparent';

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-100 to-cream-200 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center mx-auto mb-4 shadow-lg">
            <ShieldCheck size={30} className="text-white" />
          </div>
          <h1 className="font-serif text-2xl text-navy-900">Choisissez votre mot de passe</h1>
          <p className="text-navy-300 text-sm mt-0.5">Bonjour {user?.nom || user?.identifiant}, remplacez le mot de passe provisoire reçu par e-mail.</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-[22px] shadow-xl p-6 space-y-4">
          <div>
            <label className="block text-[13px] font-medium text-navy-600 mb-1.5">Mot de passe provisoire</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-navy-300" />
              <input autoFocus type="password" value={ancien} onChange={e => setAncien(e.target.value)} className={input} autoComplete="current-password" />
            </div>
          </div>
          <div>
            <label className="block text-[13px] font-medium text-navy-600 mb-1.5">Nouveau mot de passe</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-navy-300" />
              <input type="password" value={nouveau} onChange={e => setNouveau(e.target.value)} className={input} autoComplete="new-password" />
            </div>
            <ReglesMotDePasse password={nouveau} />
          </div>
          <div>
            <label className="block text-[13px] font-medium text-navy-600 mb-1.5">Confirmer le nouveau mot de passe</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-navy-300" />
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} className={input} autoComplete="new-password" />
            </div>
            {mismatch && <p className="text-[12px] text-amber-600 mt-1">Les mots de passe ne correspondent pas.</p>}
          </div>

          {error && <div className="text-[13px] text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</div>}

          <button type="submit" disabled={loading || !ancien || !mdpConforme(nouveau) || nouveau !== confirm}
            className="w-full bg-navy-800 hover:bg-navy-700 text-white py-2.5 rounded-xl font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-50">
            {loading ? 'Enregistrement…' : 'Enregistrer et continuer'}
          </button>
        </form>
        <div className="flex items-center justify-center mt-6">
          <button onClick={logout} className="text-[13px] text-navy-400 hover:text-navy-700">Se déconnecter</button>
        </div>
      </div>
    </div>
  );
}
